import * as React from "react";
import { styled, createTheme } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const PurchaseSwitchComponent = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 22,
  padding: 0,
  "& .MuiButtonBase-root": {
    position: "absolute",
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 15,
    height: 15,
  },
  "& .MuiSwitch-switchBase": {
    padding: 1,
    margin: 2,
    transitionDuration: "300ms",
    color: "#A4ADBC",
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "var(--primary-color)",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--white-color)",
        border: "1px solid var(--primary-color)",
        opacity: 1,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      color: "#A4ADBC",
      backgroundColor: "#A4ADBC",
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--white-color)",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default PurchaseSwitchComponent;
